import React from 'react';
import Card from '@mui/material/Card';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Typography from '@mui/material/Typography';

function AgentAssistCard({ children }) {
  return (
    <Card variant="outlined" style={{ borderRadius: '6px', padding: '12px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          marginBottom: '8px',
        }}
      >
        <AutoAwesomeIcon sx={{ mr: '8px', color: 'primary.main' }} />
        <Typography sx={{ variant: 'h2', color: 'primary.main', bold: 'true' }}>
          Agent Assist
        </Typography>
      </div>
      {children}
    </Card>
  );
}

export default AgentAssistCard;
